import React, { Component } from 'react';
import { connect } from 'react-redux';

export class MediaComponent extends Component {
    constructor(props) {
        super(props);
        this.user = JSON.parse(localStorage.getItem('user'));
    }

    renderStatus = (views) => {
        if (views < 200) {
            return <span className="fa fa-circle text-success"></span>;
        } else {
            return <span className="fa fa-circle text-danger"></span>;
        }
    };

    renderMedia = (url) => {
        if (!url) return <p>URL não fornecida.</p>;

        const fileExtension = url.split('.').pop().toLowerCase();

        switch (fileExtension) {
            case 'mp4':
                return (
                    <video width="200" controls>
                        <source src={url} type="video/mp4" />
                        Seu navegador não suporta a tag de vídeo.
                    </video>
                );
            case 'mp3':
                return (
                    <>
                        <audio controls>
                            <source src={url} type="audio/mp3" />
                            Seu navegador não suporta a tag de áudio.
                        </audio>
                        <br />
                        <a href={url} target="_blank" rel="noopener noreferrer">Ouvir diretamente</a>
                    </>
                );
            case 'jpg':
            case 'jpeg':
            case 'png':
            case 'gif':
                return (
                    <>
                        <img
                            src={url}
                            alt="Imagem"
                            style={{ maxWidth: '100%', height: 'auto', borderRadius: '8px' }}
                            onError={(e) => { 
                                e.target.onerror = null; 
                                e.target.src = '/assets/img/logo.png'; // Imagem de fallback
                            }}
                        />
                        <br />
                        
                    </>
                );
            case 'url':
                return (<a href={url} target="_blank" rel="noopener noreferrer">{url}</a>);

        }
    };

    render() {
        const { infoData } = this.props;

        return (
            <div>
                <h4><strong>Mídia da Campanha</strong></h4>
                <div className="card">
                    <table className="table table-bordered">
                        <thead>
                            <tr>
                                <th>URL</th>
                                <th>Views</th>
                                <th>Status</th>
                                <th>Mídia</th>
                                <th>Início</th>
                                <th>Término</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>
                                    <a
                                        href={infoData.campaign_video_view}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        Abrir
                                    </a>
                                </td>
                                <td>{infoData.video_views}</td>
                                <td className="text-center">{this.renderStatus(infoData.video_views)}</td>
                                <td>{this.renderMedia(infoData.campaign_video)}</td>
                                <td>{infoData.start}</td>
                                <td>{infoData.end}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }
}

const mapStateToProps = store => ({
    infoData: store.campaign.current,
});

export default connect(mapStateToProps)(MediaComponent);
